import { MODULES } from "./constants";

// export default function driverNames(data: any, module: string) {
//   const driverNameList =
//     (data &&
//       data.map((record: any) => {
//         let name = [];
//         if (
//           module !== MODULES.DRIVER_ASSIGNED_MODULE ||
//           (module === MODULES.DRIVER_ASSIGNED_MODULE &&
//             record.driverAssignmentStatus === true)
//         ) {
//           name =
//             record.shipmentInvolvedParties &&
//             record.shipmentInvolvedParties.find((data: any) => {
//               return data.partyType === "PRIMARY DRIVER";
//             });
//         }
//         if (
//           module === MODULES.DRIVER_ASSIGNED_MODULE &&
//           record.driverAssignmentStatus === false
//         ) {
//           name =
//             record.assignmentTransaction &&
//             record.assignmentTransaction[0];
//         }
//         return {name : (name && name.partyName !== null && name.partyName) || (name && name.driverName !== null && name.driverName) || null,partyId : name?.partyId || name?.driverId};
//       })) ||
//     [];
//     const uniqueDrivers = driverNameList.filter((currentValue:any, index:number) => driverNameList.findIndex((item:any) => currentValue?.partyId === item?.partyId) === index)
//   return [
//     ...uniqueDrivers,
//     {name : "All Drivers",partyId: "All_Drivers"},
//     {name:"Unknown",partyId: "Unknown"}
//   ];
// }
export default function driverNames(data: any) {
  const refinedData = data?.map((driver:any)=>{return {name :`${driver?.firstName} ${driver?.lastName}` ,partyId :(driver?.userPrincipalName || driver?.upn) ||driver?.mobileNumber || driver?.email}})
  return [
    ...refinedData,
    {name : "All Drivers",partyId: "All_Drivers"},
    {name:"Unknown",partyId: "Unknown"}
  ];
}
